module.exports = __webpack_public_path__ + "images/company/rank_medal/assessment_achievement_count_rank/5_4aca2c3e261b517092312f6e349f5988.png";